import HHEvents from './events'

export default window.HHUI = new class {

	displayBoard() {
		HHEvents.fire(HHEvents.DISPLAY_BOARD);
	}

	error(err) {
		HHEvents.fire(HHEvents.ERROR, err);
	}

	gameOver(winner) {
		HHEvents.fire(HHEvents.GAME_OVER, winner);
	}

	initiatePlayerTurn(player) {
		HHEvents.fire(HHEvents.INITIATE_PLAYER_TURN, player);
	}

	loadingEnd() {
		HHEvents.fire(HHEvents.LOADING_END);
	}

	loadingStart() {
		HHEvents.fire(HHEvents.LOADING_START);
	}

	toggleGrid(enabled) {
		HHEvents.fire(HHEvents.TOGGLE_GRID, enabled);
	}

	/**
	 * @param {number[][]} move Array of `[X,Y,D,P]` vectors to be placed on board
	 * @param {number[][]} remove Array of `[X,Y,D,P]` vectors to be removed from board
	 * @param {number} conflicts Conflicts indicator
	 * @param {number} partyTurn Party turn index
	 */
	updateBoard(move, remove, conflicts, partyTurn) {
		HHEvents.fire(HHEvents.UPDATE_BOARD, { move, remove, conflicts, partyTurn });
	}
}
